import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function ResetPassword() {
  const { updatePassword, signOut } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await updatePassword(pw);
      if (error) throw error;
      toast.success("Contraseña actualizada. Inicia sesión de nuevo.");
      await signOut();
      nav("/auth");
    } catch (err) {
      toast.error(err?.message || "No se pudo actualizar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0B0B0B] px-5">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        <div className="rounded-2xl border border-[#27272A] bg-[#141416] p-6 sm:p-8">
          <h1 className="font-heading text-2xl font-extrabold text-white">Nueva contraseña</h1>
          <p className="mt-1 text-sm text-gray-400">Define una nueva contraseña para tu cuenta.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="relative">
              <Lock size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-500" />
              <input
                type="password"
                required
                minLength={6}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                placeholder="Nueva contraseña"
                data-testid="reset-password-input"
                className="w-full rounded-xl border border-[#27272A] bg-[#0d0d0f] py-3 pl-11 pr-3 text-sm text-white placeholder-gray-500 outline-none focus:border-[#FF6A00]"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="reset-password-submit"
              className="w-full rounded-xl bg-[#FF6A00] py-3.5 font-extrabold text-black transition-transform active:scale-95 disabled:opacity-60"
            >
              {loading ? "Guardando…" : "Actualizar contraseña"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
